import { GET_COO_STATISTICS_URL } from '../../services/api/coo-statistics/CooStatisticsApi';
import legacy from '../../services/api/axios';

export const get_total_bizdev_turbo_revenue = async (selectedYear, selectedCountry) => {
  const initialDateClicked = {
    from: `${selectedYear}-01-01`,
    to: `${selectedYear}-12-31`,
  };

  const initialExpirationState = {
    action: 'get_bizdev_turbo_revenue',
    ...initialDateClicked,
    country: selectedCountry,
  };

  const formData = new FormData();
  Object.entries(initialExpirationState).forEach(([key, value]) => {
    formData.append(key, value);
  });

  try {
    const headers = {
      Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      // Remove content-type here - let Axios set it automatically for FormData
    };

    // Add withCredentials to handle CORS properly
    const res = await legacy.post(`${GET_COO_STATISTICS_URL}`, formData);

    if (res.data) {
      return res.data;
    }
  } catch (error) {
    console.error('API Error:', error.response || error);
  }
};
